import React, { useState, useEffect } from 'react'
import { CameraIcon } from 'lucide-react'
import BlankProfileImage from '../../../../assets/images/blank-profile-pic.png'
import axios from 'axios'
import { useAlert } from '../../../constants/AlertProvider'
import Cookies from 'js-cookie'
import ImageModal from '../../common/ImageModal'

export default function EditProfileHeader() {
    const [profileImage, setProfileImage] = useState(BlankProfileImage)
    const [name, setName] = useState('')
    const [title, setTitle] = useState('')
    const [previewImage, setPreviewImage] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const showAlert = useAlert();

    // Fetch user info (name, title, image) on mount
    useEffect(() => {
        const fetchProfile = async () => {
            try {
                const userId = Cookies.get("id");
                const res = await axios.get(`/api/users/${userId}/`);
                setName(res.data.name || 'Jane Cooper');
                setTitle(res.data.title || 'Software Developer');
                if (res.data.profile_picture) {
                    setPreviewImage(res.data.profile_picture);
                    setProfileImage(res.data.profile_picture);
                }
            } catch (e) {
                showAlert("Failed to load profile info", "error");
            }
        }
        fetchProfile();
    }, []);

    const handleImageCropped = async (croppedFile) => {
        setPreviewImage(URL.createObjectURL(croppedFile));
        setIsModalOpen(false);

        const userId = Cookies.get("id");
        const csrfToken = Cookies.get("csrftoken");
        try {
            const formData = new FormData();
            formData.append("profile_picture", croppedFile);

            await axios.patch(
                `/api/users/${userId}/`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        "X-CSRFToken": csrfToken,
                    },
                    withCredentials: true,
                }
            );
            showAlert("Profile image updated", "success");
        } catch (e) {
            showAlert("Failed to upload image", "error");
        }
    };

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    }

    return (
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700">
            <div className="h-32 bg-gradient-to-r from-blue-300 to-blue-600"></div>
            <div className="px-6 pb-6 relative">
                <div className="absolute -top-24 flex items-end">
                    <div className="relative">
                        <div className="inline-block p-[4px] bg-gradient-to-r from-blue-300 via-indigo-400 to-purple-500 rounded-full">
                            <img
                                src={previewImage || profileImage}
                                alt="Profile"
                                className="w-32 h-32 rounded-full object-cover bg-white dark:bg-gray-800"
                            />
                        </div>
                        <div className="absolute bottom-0 right-0">
                            <button
                                type="button"
                                onClick={toggleModal}
                                className="flex items-center justify-center w-10 h-10 rounded-full bg-blue-600 hover:bg-blue-700 cursor-pointer border-2 border-white dark:border-gray-800"
                            >
                                <CameraIcon size={18} className="text-white" />
                            </button>
                            {isModalOpen && (
                                <ImageModal
                                    closeModal={toggleModal}
                                    onImageCropped={handleImageCropped}
                                />
                            )}
                        </div>
                    </div>
                    <div className="ml-4">
                        <h2 className="text-xl font-bold text-gray-800 dark:text-gray-100">{name}</h2>
                        <p className="text-gray-500 dark:text-gray-400">{title}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}